<template>
  
  <form id="configForm" autocomplete="off" :class="[
                  { 'md-warning': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
                ]">

    <div class="md-autocomplete-loading" v-show="isPromisePending">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>
    <CaseCrudToolbar
      :btnActive="!$v.form.$invalid && $v.form.$anyDirty"
      :atShowAuditLog="atShowAuditLog"
      :save="saveCaseTemplate"
      :form="form"
      :$v="$v"
      :formConfig="formConfig"
      :cancel="cancel"
      :reassignTasks="reassignTasks"
      :recordData="recordData"
      :field="formConfig.fields.caseUserId"
      :isSaveInProgress="isSaveInProgress"
    ></CaseCrudToolbar>

    <div class="md-layout">
      <grid-layout
        :layout.sync="formLayout"
        :col-num="12"
        :is-draggable="false"
        :is-resizable="false"
        :auto-size="false"
        :is-mirrored="false"
        :vertical-compact="true"
        :responsive="false"
        :margin="[10, 10]"
        :use-css-transforms="true"
      >
        <grid-item v-for="(slot, slotName, index) in formConfig.slots" :id="slotName"
                  :x="slot.layout.x"
                  :y="slot.layout.y"
                  :w="slot.layout.w"
                  :h="slot.layout.h"
                  :i="slot.layout.i"
                  :key="'griditem_'+ slotName + slot.layout.i"
        >
      <div v-if="!slot.inSidePanel">
        <div v-if="slot.editModeOnly && formConfig.pageMode == 'new'" :key="slotName" class="vue-grid-item-content">
          <h3><span class="heading">{{slot.label}}</span></h3>Create a base record to enable this section.
        </div>
        <div v-else :key="slotName" class="vue-grid-item-content">
           <div v-if="$v && $v.form && showRequirements" class="requirementsNotice">
            <h4>The following fields require attention:</h4>
            <template v-for="(slot, slotName, index) in formConfig.slots">
              <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">
                <template v-if="$v.form[name] && $v.form[name].$invalid">
                <p :key="`${name}-${index}`" :data-target="name" @click="scrollToField(name)" class="required-field-label">
                  <span class="fa-stack fa-sm" v-if="field.label === 'isAllowSave' ? 'Task' : field.label">
                    <i class="far fa-circle fa-stack-2x text-danger"></i>
                    <i class="fas fa-times fa-stack-1x text-danger"></i>
                    <!-- <i class="far fa-circle fa-stack-2x text-success"></i>
                    <i class="fas fa-check fa-stack-1x text-success"></i> -->
                  </span>
                  {{field.label === "isAllowSave" ? "Task" : field.label}}
                </p>
                </template>
              </template>
            </template>
          </div>
            <h3><span class="heading" :id="slot.id">{{slot.label}}</span></h3>
          <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">

            <CrudCheckbox
              v-if="field.type == 'checkbox'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>

            <CrudSearchModal
              v-else-if="field.type == 'searchmodal'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field" :recordData="recordData" :filter="field.filter" :atChangeTargetVal="atChangeTargetVal"></CrudSearchModal>

            <CrudDatepicker
              v-else-if="field.type == 'datepicker'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

            <CrudSelect
              v-else-if="field.type == 'select'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

            <CrudAutocomplete
              v-else-if="field.type == 'autocomplete'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

            <CrudJson
              v-else-if="field.type == 'json'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

            <CrudSwitch
              v-else-if="field.type == 'switch'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSwitch>

            <CrudId
              v-else-if="field.type == 'id'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

            <CrudText
              v-else :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>

          </template>
        </div>
        
        <gridItemHook />
      </div>


      <!-- for Sidepanel config fields -->
      <portal :to="`sidepanel-portal-${slotName}`" v-if="slot.inSidePanel">
        <div :key="slotName" class="vue-grid-item-content">
          <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">

            <CrudCheckbox
              v-if="field.type == 'checkbox'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>

            <CrudSearchModal
              v-else-if="field.type == 'searchmodal'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field" :recordData="recordData"  :filter="field.filter" :atChangeTargetVal="atChangeTargetVal"></CrudSearchModal>

            <CrudDatepicker
              v-else-if="field.type == 'datepicker'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

            <CrudSelect
              v-else-if="field.type == 'select'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

            <CrudAutocomplete
              v-else-if="field.type == 'autocomplete'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

            <CrudJson
              v-else-if="field.type == 'json'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

            <CrudSwitch
              v-else-if="field.type == 'switch'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSwitch>

            <CrudId
              v-else-if="field.type == 'id'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

            <CrudText
              v-else :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>

          </template>
        </div>
        <gridItemHook />
      </portal>
        </grid-item>
      </grid-layout>
    </div>
    

    <!-- Task List on Edit Case -->
    <div class="caseTaskList" id="caseTasks">
      <CustomCaseTaskList 
            v-show="formConfig.pageMode != 'view' && formConfig.pageMode != 'assignee'"
            :list.sync="tasksList"
            :filter="taskCaseIdFilter"
            :templateTasks="templateTasks"
            :existingTasks="existingTasks"
            @tasksChanged="onTasksChanged"
            :isCompleteInOrder="isCompleteInOrder"
      ></CustomCaseTaskList>
    </div>
</form>

</template>

<script>
  import RecordForm from '@/mixins/RecordForm';
  import VueGridLayout from 'vue-grid-layout';
  import CustomCaseTaskList from "@/components/DynamicForm/CustomCaseTaskList";

  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as mutations from '@/graphql/mutations';
  import * as queries_custom from '@/graphql/queries_custom';
  import _ from 'lodash';

  const gridItemHook = {
    mounted(){
      // [i] This pushes each gridItem into this.gridItems below for config-form
      // this.$parent.$parent.$parent.gridItems.push(this.$parent);
      const gridItems = this.$reduce(this, '$parent.$parent.$parent.gridItems');
      if (gridItems && gridItems.length) {
        gridItems.push(this.$parent);
      }
    },
    render(h){
      return h('div', [h('div',{attrs: {contentEditable: true, class: 'editable'}})])
    }
  };

  export default {
    name: "custom-case-config-form",
    mixins: [RecordForm],
    components: {
      CustomCaseTaskList,
      GridLayout: VueGridLayout.GridLayout,
      GridItem: VueGridLayout.GridItem,
      gridItemHook
    },
    props: {
	    atShowAuditLog: {
        type: Function,
        required: true
	    },
      templateTasks: {
        type: Object,
        required: true
      },
      existingTasks: {
        type: Object,
        required: true
      },
      isCompleteInOrder: {
        type: [Boolean, null, undefined],
        required: false
      },
      setCloseDate: {
        type: Boolean,
        required: false
      },
      reassignTasks: {
        type: [Object, Array],
        required: false
      },
      atChangeTargetVal: {
        type: Function,    
	    },
    },
    computed: {
      taskCaseIdFilter: function () { return {"taskCaseId": {"eq": this.$route.params.id }}; },
      showRequirements() {
        let result = false;
         if (this.formConfig && this.formConfig.pageMode === 'new' && this.$v.form.$invalid && !this.$route.params.id) {
          result = true;
        }
        if(this.formConfig.pageMode === 'edit'){
          if(this.recordData && this.recordData.id && this.$v.form.$invalid){
            result = true;
          }
        }
        return result;
      },
    },
    data() {
      return {
        formLayout: [//default value so that at least it works
          {"x":0,"y":0,"w":2,"h":2,"i":"0"},
          {"x":2,"y":0,"w":2,"h":4,"i":"1"},
          {"x":4,"y":0,"w":2,"h":5,"i":"2"},
          {"x":6,"y":0,"w":2,"h":3,"i":"3"},
          {"x":8,"y":0,"w":2,"h":3,"i":"4"},
          {"x":10,"y":0,"w":2,"h":3,"i":"5"},
          {"x":0,"y":5,"w":2,"h":5,"i":"6"},
          {"x":2,"y":5,"w":2,"h":5,"i":"7"},
          {"x":4,"y":5,"w":2,"h":5,"i":"8"},
          {"x":6,"y":4,"w":2,"h":4,"i":"9"},
          {"x":8,"y":4,"w":2,"h":4,"i":"10"},
          {"x":10,"y":4,"w":2,"h":4,"i":"11"},
          {"x":0,"y":10,"w":2,"h":5,"i":"12"},
          {"x":2,"y":10,"w":2,"h":5,"i":"13"},
          {"x":4,"y":8,"w":2,"h":4,"i":"14"},
          {"x":6,"y":8,"w":2,"h":4,"i":"15"},
          {"x":8,"y":10,"w":2,"h":5,"i":"16"},
          {"x":10,"y":4,"w":2,"h":2,"i":"17"},
          {"x":0,"y":9,"w":2,"h":3,"i":"18"},
          {"x":2,"y":6,"w":2,"h":2,"i":"19"}
        ],
        gridItems: [],
        isSaveInProgress: false, //toggle Save button
        scrollActive: false,
        tasks: [],
        tasksList: {
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "tasks",
          pageTitle: "Add Tasks",
          pageIcon: "assignment_ind",
          listQueryId: "searchTasks",
          deleteQueryId: "deleteTask",
          //deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to delete {objectName}?",
          deleteMessageText: "",
          deleteMessageNameFields: ['subject'],
          columns: {
            group: { label: "Group" },
            subject: { label: "Task", sortable: true },
            status: { label: "Status", sortable: true },
            user: { label: "Assignee", sortable: true },
            dateDue: { label: "dateDue", sortable: true },
          },
          fuseSearch: null,
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
          },
          tableData: [],
          searchedData: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchTasks && data.searchTasks.items.length) {
              result = data.searchTasks.items;
            }
            return result;
          },
        },
        reassignTasksUpdate: false
      }
    },
    beforeMount() {
      let layout = [];
      this.$loopo(this.formConfig.slots, (slot) => {
        layout.push(slot.layout);
      });
      if (layout.length) {
        this.formLayout = layout;
      }
    },
    updated() {
      this.gridItems.forEach(gridItem => {
        gridItem.autoSize();
      });
    },
    watch: {
      templateTasks: {
        handler: function(newVal, oldVal) {
          this.templateTasks = newVal;
        },
        immediate: true
      },
      existingTasks: {
        handler: function(newVal, oldVal) {
          this.existingTasks = newVal;
          console.log('existingTasks',this.existingTasks);
        },
        deep: true
      },
      setCloseDate: {
        handler: function(newVal, oldVal) {
          this.setCloseDate = newVal;
        },        
      },
      /**
       * ATLAS-1050: <Case><Task> Case Task Reassignment
       * Watch skipReassignTasks value after task selection from dialog & call saveCaseTemplate()
       */
      'reassignTasks.skipReassignTasks': {
        immediate: true,
        handler: function() {
          if (this.reassignTasks.skipReassignTasks) {
            console.log("skipReassignTasks: ", this.reassignTasks.skipReassignTasks);

            this.reassignTasksUpdate = true;
            this.saveCaseTemplate();
          }
        }
      }
    },
    mounted () { 
      window.addEventListener('scroll', this.handleScroll);

      // Reset the toolbar (form controls and tab navigation)
      let topPageToolbar = window.document.getElementById("topPageToolbar");
      if (topPageToolbar) {
        topPageToolbar.innerHTML = '';
      }

      let caseToolbarControls = window.document.getElementById("caseToolbarControls");
      if (!caseToolbarControls) {
        return;
      }

      //Save a reference to the parent BEFORE you move these!
      let parent = caseToolbarControls.parentElement;

      if (caseToolbarControls && caseToolbarControls.parentElement.id !== "topPageToolbar") {
        topPageToolbar.append(caseToolbarControls);
      }

      let caseToolbarStatusControl = window.document.getElementById("caseToolbarStatusControl");
      if (caseToolbarStatusControl && caseToolbarStatusControl.parentElement.id !== "topPageToolbar") {
        topPageToolbar.append(caseToolbarStatusControl);
      }

      let caseToolbarAssignControl = window.document.getElementById("caseToolbarAssignControl");
      if (caseToolbarAssignControl && caseToolbarAssignControl.parentElement.id !== "topPageToolbar") {
        topPageToolbar.append(caseToolbarAssignControl);
      }
      
      if (parent.id !== "topPageToolbar") {
        parent.remove();
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll() {
        this.scrollActive = true;
      },
      onTasksChanged(tasks) {
        this.tasks = tasks;
        console.log(this.tasks);

        //ATLAS-1734: <Case> Do not allow save case without at least 1 task
        if (this.tasks.length) {
          this.$emit('isSaveButtonEnable', true);
        } else {
          this.$emit('isSaveButtonEnable', false);
        }
      },
      scrollToField(target){
        if(target === 'isAllowSave'){
          target = 'caseTasks'
        }

        const selector = `.vue-grid-item-content [name="${target}"]`;
        const eleTarget = document.querySelector(selector);
        if (eleTarget) {
          const eleParent = eleTarget.closest('.field')
          if(eleParent) {
            eleParent.scrollIntoView({
              behavior:"smooth"
            });
          } else {
            eleTarget.scrollIntoView({
              behavior:"smooth"
            });
          }
        }
        else{
          const targetEle = document.getElementById(target);
          targetEle.scrollIntoView(true)
        }
      },
      //save manually created case and tasks
      async saveCaseTemplate() {
        /**
         * ATLAS-1050: <Case><Task> Case Task Reassignment
         * Show dialog if new assignee selected
         */
        if(
          this.reassignTasks && this.reassignTasks.newAssigneeId && 
          this.reassignTasks.assigneeId != this.reassignTasks.newAssigneeId &&
          this.reassignTasks.reassignTasks && this.reassignTasks.reassignTasks.length > 0 &&
          !this.reassignTasks.closeDialogClicked && !this.reassignTasksUpdate
        ) {
          this.reassignTasks.showRelatedDialog = true;
          return;
        }

        //reset to allow displaying dialog
        this.reassignTasksUpdate = false;
        this.reassignTasks.closeDialogClicked = false;

        this.isPromisePending = true;
        this.isSaveInProgress = true; //disable Save button
        this.$v.form.$touch();
        if(this.$v.form.$invalid) {
          this.isPromisePending = false;
          this.$c.log('save(): unable to save, $v.form.invalid');
          return;
        }
        let data = {};
        const form = this.form;
        const fields = this.formConfig.fields;
        this.$loopo(fields, (field, name) => {
          if (!field.fields) {
            if (typeof form[name] !== 'undefined' && form[name] !== null) {
              if (field.type === 'datepicker') {
                try{
                  data[name] = form[name].toUTCString();
                }catch (e) {
                  data[name] = form[name].toString();
                  console.log('datepicker try catch ',form[name])
                }
              } else {
                data[name] = form[name];
              }
            }
          } else {
            if (field.type === 'json') {
              data[name] = JSON.stringify(form[name].fields);
            }
          }
        });
        // We should not send any empty strings on create
        if (this.formConfig.pageMode == 'new') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                delete data[name];
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  delete data[name];
                }
              }
            }
          });
        }
        if (this.formConfig.pageMode == 'edit' || this.formConfig.pageMode == 'assignee') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                data[name] = null;
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  data[name] = null;
                }
              }
            }
          });
        }
        if (this.formConfig.removeFields && this.formConfig.removeFields.length) {
          this.formConfig.removeFields.forEach(item => {
            delete data[item];
          });
        }
      
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByFieldName');
        if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
          data[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }

        /**
         * ATLAS-887 - add closedDate to case 
         */
        if ((data.status === 'Closed_Completed' || data.status === 'Closed_Unresolved') && this.setCloseDate) {
          data.closedDate = new Date().toISOString();
        } else {
          if(data.status != 'Closed_Completed' && data.status != 'Closed_Unresolved'){
            /**
             * https://zeamster.atlassian.net/browse/ATLAS-1633
             * manual case creation log is not getting generated
             */
            // data.closedDate = null;
            delete(data.closedDate);
          }          
        }

        // ATLAS-1469 <Cases<time stamp for statuses exposing in the UI.
        if (this.formConfig.pageMode == 'new' && data.caseUserId) {
          data.lastAssignDate = new Date().toISOString();
        }

        await this.createCase(data);
      },
      async createCase(data) {
        let caseId = this.$route.params.id;
        this.isPromisePending = true;
        let query = this.getMutation((this.formConfig.pageMode === 'edit' || this.formConfig.pageMode == 'assignee') ? this.formConfig.actions.update : this.formConfig.actions.save);
        const result = await API.graphql(graphqlOperation(query, {input: data}))
        .then(result => {
          let responseKey = (this.formConfig.pageMode === 'new'? 'create' : 'update') + this.formConfig.objectName;
          let responseId = result.data[responseKey].id
          this.$c.log("success! responseKey = " + responseKey);
          this.$c.log("success! responseId = " + responseId);
          this.isPromisePending = false;
          
          if(!_.isEmpty(this.$route.query) && this.formConfig.pageMode === 'new'){
            if(this.$router.metaData){
                this.addRelateRecord(responseId);
            }            
          }          
          let taskArr = [];
          this.tasks.forEach((_element, _elementIndex) => {
            _element.items.forEach((_itemElement, _itemIndex) => {
              taskArr.push(_itemElement)  
            });
          });
          console.log(taskArr);
          let recordArr = [];
          if(this.existingTasks && this.existingTasks.items) {
            recordArr = JSON.parse(JSON.stringify(this.existingTasks.items));
          }       
          console.log(recordArr);
          let deletePromiseArr = [];          
          recordArr.forEach((_recordElement, _recordIndex) => {
            
            let indexFound = _.findIndex(taskArr, {
              id: _recordElement.id
            });
            if (indexFound == -1)
            {
              console.log("Delete",_recordElement);
              let deleteTaskData = {
                id: _recordElement.id
              };
              let gqlRequest = API.graphql(graphqlOperation(mutations['deleteTask'], {input: deleteTaskData}));
              deletePromiseArr.push(gqlRequest);
            }          
          });
          this.isPromisePending = true;
          Promise.all(deletePromiseArr).then((resultPromise) => {
            this.isPromisePending = false;
            this.$c.log('Case Tasks Removed Successfully');
            console.log(resultPromise);
          });

          //create tasks for manually created case
          if (this.tasks.length) {
            this.isPromisePending = true;
            let promiseArr = [];
            let stepsArr = [];
            let promiseStepsArr = [];
            this.tasks.forEach((_element, _elementIndex) => {
              _element.items.forEach((_itemElement, _itemIndex) => {
                let isAvailable = true;
                if (this.form && this.form.isCompleteInOrder) {
                  // All pending tasks in first group should be available
                  // @see https://zeamster.atlassian.net/browse/ATLAS-879
                  // @see CustomTaskForm.vue
                  // Updated the logic for status = 'closed_by_workflow' as per ATLAS-1170
                  if (0 == _elementIndex &&  'completed' != _itemElement.status && 'closed_by_workflow' != _itemElement.status) {
                    isAvailable = true;
                  } else {
                    isAvailable = false;
                  }
                }

                let caseTemplateTaskData = {
                  order: _itemIndex + 1,
                  group: _elementIndex + 1,
                  isTemplate: false,
                  isAvailable: isAvailable,
                  isCompleteInOrder: _itemElement.isCompleteInOrder,
                  type: _itemElement.type,
                  dateDue: _itemElement.dateDue ? _itemElement.dateDue : new Date(),
                  subject: _itemElement.subject,
                  internal: _itemElement.internal ? true : false,
                  priority: _itemElement.priority,
                  status: _itemElement.status,
                  dateCompleted: _itemElement.dateCompleted,
                  taskCaseId: responseId,
                }
                let updateCaseTaskOrdering = {
                  order: _itemIndex + 1,
                  group: _elementIndex + 1,
                  taskCaseId: responseId,
                }
                if (_itemElement.user && _itemElement.user.id) {
                    caseTemplateTaskData.taskUserId = _itemElement.user.id;                  
                } else if (_itemElement.taskUserId) {
                  caseTemplateTaskData.taskUserId = _itemElement.taskUserId;
                } else {
                  caseTemplateTaskData.taskUserId = this.$Session.userId;
                }
                
              //ATLAS-1194: pull out this if block from if(_itemElement.user && _itemElement.user.id)
              //ATLAS-961: if reassignTasks array exist
              if(this.reassignTasks && this.reassignTasks.selectedTasks && this.reassignTasks.selectedTasks.length) {

                //loop through and match taskId to reassign existing taskUserId
                this.reassignTasks.selectedTasks.forEach(el => {
                  if(el.taskId === _itemElement.id) {
                    let caseTaskData = {};
                    caseTaskData['taskUserId'] = el.taskUserId;
                    caseTaskData['skipAlert'] = el.skipAlert;
                    caseTaskData['id'] = _itemElement.id;
                    caseTaskData['taskUpdatedById'] = this.$Session.userId
                    
                    let gqlRequest = API.graphql(graphqlOperation(mutations["updateTask"], {input: caseTaskData}));
                    promiseArr.push(gqlRequest);

                    //task steps array
                    let objForSteps = {
                      itemIndex : _elementIndex,
                      steps : _itemElement.steps.items
                    }
                    stepsArr.push(objForSteps);
                  }
                });
              }


                /**
                 * ATLAS-877 - Add Updatedby to all Models in the Schema
                 * @see https://zeamster.atlassian.net/browse/ATLAS-877
                 */
                const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskFieldName');
                if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
                  caseTemplateTaskData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
                }
                
                console.log("Create Task: ", this.existingTasks);
                //if new task added in Case Task list
                if (!(_itemElement.case && _itemElement.case.id && _itemElement.case.id == caseId))
                {
                  let taskKey = (_itemElement.isTemplate ? 'create' : 'update') + 'Task';
                  if (taskKey == 'updateTask') 
                    caseTemplateTaskData['id'] = _itemElement.id;
                  let gqlRequest = API.graphql(graphqlOperation(mutations[taskKey], {input: caseTemplateTaskData}));
                  promiseArr.push(gqlRequest);
                  let objForSteps = {
                    itemIndex : _elementIndex,
                    steps : _itemElement.steps.items
                  }
                  stepsArr.push(objForSteps);
                } else if (_itemElement.case && _itemElement.case.id && _itemElement.case.id == caseId) {
                  //only reorder existing tasks
                  updateCaseTaskOrdering['id'] = _itemElement.id;
                  let gqlRequest = API.graphql(graphqlOperation(mutations["updateTask"], {input: updateCaseTaskOrdering}));
                  promiseArr.push(gqlRequest);
                  let objForSteps = {
                    itemIndex : _elementIndex,
                    steps : _itemElement.steps.items
                  }
                  stepsArr.push(objForSteps);
                }
              });
            });
            console.log(promiseArr);

            Promise.all(promiseArr).then((resultPromise) => {
              if (this.formConfig.pageMode === 'assignee') {
                window.$bus.$emit('caseTaskView.forceUpdate');
              }
              this.isPromisePending = false;
              this.$c.log('Case Template Tasks Inserted Successfully');
              console.log(resultPromise);
              console.log(stepsArr);
              
              for(let i=0; i<resultPromise.length; i++) {
                
                /**
                 * @see https://zeamster.atlassian.net/browse/ATLAS-646
                 * @see CustomTaskForm.vue
                 * when a task should be completed in order, while saving or 
                 * updating the task - we mark the first step that is not
                 * complete as available and mark all other steps as not available
                 */
                let isFirstTaskStepMadeAvailable = false;
                let taskResponseData = resultPromise[i].data.createTask;
                let sortedTaskSteps = _.sortBy(stepsArr[i].steps, 'order');
                let isUpdate = false;

                /**
                 * ATLAS-677
                 * Notification - User is not receiving Notification alert for first 
                 * task which says isAvailable=True while applying 
                 * Complete in order = True template
                 */
                if (
                  this.form && 
                  this.form.isCompleteInOrder && 
                  taskResponseData && 
                  taskResponseData.isAvailable
                ) {
                  const userId = this.$reduce(taskResponseData, 'user.id');
                  const owner = this.$reduce(taskResponseData, '$Session.user.username');
                  const taskAlert = {
                    type: 'taskAssignment',
                    subject: 'A task has been assigned to you.',
                    body: taskResponseData.subject,
                    link: '#/tasks/' + taskResponseData.id,
                    owner: owner,
                    alertUserId: userId,
                    level: 'notice',
                    status: 'Unread',
                  };
                  // ATLAS-1216 Notifications should not be sent when case/tasks are assigned to SELF
                  if(userId === this.$Session.userId){
                      console.log('Notifications should not be sent when case/tasks are assigned to SELF')
                  }else{
                    API.graphql(graphqlOperation(mutations.createAlert, { input: taskAlert }));
                  }
                }
                
                // a new task was created - after case is saved - it is updated
                // and attached to the case
                if (!taskResponseData && resultPromise[i].data.updateTask) {
                  taskResponseData = resultPromise[i].data.updateTask;
                  isUpdate = true;
                }
                
                for(let j=0; j< sortedTaskSteps.length; j++) {
                  let taskStepData = sortedTaskSteps[j];
                  
                  // mark the first step that is not complete as available
                  // check ATLAS-646 comment above
                  if (taskResponseData && taskResponseData.isCompleteInOrder) {
                    if (isFirstTaskStepMadeAvailable) {
                      taskStepData.isAvailable = false;
                    } else {
                      let status = '';
                      if (taskStepData && taskStepData.status) {
                        status = taskStepData.status.toLowerCase();
                      }
                      if ('complete' != status) {
                        taskStepData.isAvailable = true;
                        isFirstTaskStepMadeAvailable = true;
                      } else {
                        taskStepData.isAvailable = false;
                      }
                    }
                  } else {
                    taskStepData.isAvailable = true;
                  }
                  
                  if (taskResponseData) {
                    // if task data found and in update mode then update steps
                    // else create new steps
                    if (isUpdate) {
                      promiseStepsArr.push(this.updateStep(taskStepData, taskResponseData.id));
                    } else {
                      promiseStepsArr.push(this.createStep(taskStepData, taskResponseData.id));
                    }
                  }
                }
              }
              Promise.allSettled(promiseStepsArr).then((resultStepsPromise) => {
                this.$c.log('Case Template Tasks Steps Inserted Successfully');
              })

              this.isSaveInProgress = false; //enable Save button
              this.$router.push(this.formConfig.listPath + '/' + responseId);
              this.loadData(result.data[responseKey]);
            });  
          } else {
            this.isSaveInProgress = false; //enable Save button
            this.$router.push(this.formConfig.listPath + '/' + responseId);
            this.loadData(result.data[responseKey]);
          }          
        })
        .catch(error => {
          this.$c.log(error);
        });
      },
      createStep (stepData, taskId) {
        //ATLAS-815 Default Task Step status - Open
        let inputStepData = {
          title: stepData.title,
          description: stepData.description,
          taskStepTaskId: taskId,
          status: (stepData.status === null ? "Open" : stepData.status),
          isAvailable: stepData.isAvailable,
          order: stepData.order
        };
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskStepFieldName');
        if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
          inputStepData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }
        
        let gqlRequest = graphqlOperation(mutations['createTaskStep'], {input: inputStepData});
        this.$c.log('gqlRequest create step', gqlRequest);
        return API.graphql(gqlRequest)
      },
      updateStep (stepData, taskId) {
        //ATLAS-815 Default Task Step status - Open
        let inputStepData = {
          id: stepData.id,
          title: stepData.title,
          description: stepData.description,
          taskStepTaskId: taskId,
          status: (stepData.status === null ? "Open" : stepData.status),
          isAvailable: stepData.isAvailable,
          order: stepData.order
        };
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskStepFieldName');
        if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
          inputStepData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }
          
        let gqlRequest = graphqlOperation(mutations['updateTaskStep'], { input: inputStepData });
        this.$c.log('gqlRequest update step', gqlRequest);
        return API.graphql(gqlRequest)
      },
      async addRelateRecord(recordId) {
        let data = this.$router.metaData;
        let input = data.relateRecordInput;
        input[data.relateRecordInputField] = recordId;
//      [i] ATLAS-1481 - Commenting this out as this is how handled in auditTrail
//      if (data.relateRecordInputField === "caseServiceCaseId") {
//        this.addAccountRecord(data, recordId)
//      }
        await API.graphql(graphqlOperation(mutations[data.createMutationId], {input: input}))
          .then( res => {
            this.$router.metaData = null
            console.log('SUCCESS')
          })
          .catch(error => {
            this.$c.log(" adding record error:", error);
        });
      },
      async addAccountRecord(data, recordId) {
        let inputService = { "id": data.relateRecordInput.caseServiceServiceId }
        const operation = graphqlOperation(
          queries_custom.getServiceAccount,
          inputService
        );
        const result = await API.graphql(operation);
        console.log('queries_custom.getServiceAccount', result)
        if (result && result.data.getService && result.data.getService.account && result.data.getService.account.id) {
          const input = { caseAccountAccountId: result.data.getService.account.id, caseAccountCaseId: recordId }
          await API.graphql(graphqlOperation(mutations["createCaseAccount"], {input: input}))
            .then( res => {
              console.log('SUCCESS')
            })
            .catch(error => {
              this.$c.log(" adding record error:", error);
          });
        }
      }
    }
  };
</script>

<style lang="scss">
  .crud-toolbar {
    .md-button {
      margin-top: .3125rem !important;
    }
    .md-card .md-card-header.md-card-header-icon i {
      margin-top: -8px;
    }
  }
  input.is-danger {
    border: 2px solid red;
  }

  .md-content.md-theme-default.md-tabs-content {
    background-color: transparent !important;
    height: auto !important;
  }

  form {

    .md-toolbar.md-transparent {
      background-color: #FFF !important;
    }

    &.md-warning {
      background-color: #e57373;

      .md-toolbar.md-transparent {
        background-color: #FFF !important;
      }

    }

    .vue-grid-item-content {
      display: flex;
      flex-wrap: wrap;
      background-color: #FFF;
      padding-left: 30px;
    }


    .md-field.md-autocomplete {
      .md-input-action.md-button.md-clear {
        width: 20px;
        height: 20px;
        min-width: 20px;
        right: 25px;
        top: 5px;
      }
    }

    fieldset {
      border: none;
      padding: 0;
      width: 100%;
      margin: 0;

      legend {
        margin-bottom: 0;
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        h5 {
          margin-bottom: 0;
        }
      }
    }
  }

  .md-tab .md-layout .md-card.md-theme-default {
    margin-bottom: 0;
    margin-top: 15px;
  }
  .md-layout > form {
    width: 100%;
  }

  .requirementsNotice {
    background-color: lightyellow;
    border: 1px solid black;
    border-radius: 5px;
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;

    h4 {
      margin-top: 0;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: bold;
    }
    p {
      margin-bottom: 0;
      margin-top: 5px;
    }
    .fa-stack.fa-sm {
      font-size: 10px;
    }
    .required-field-label {
      color: #2196f3;
      cursor: pointer;
    }
  }
</style>
